import { Injectable } from '@angular/core';
import Swal from 'sweetalert2';

@Injectable({
  providedIn: 'root',
})
export class AlertService {
  private toast = Swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
  });

  private modal = Swal.mixin({
    allowOutsideClick: false,
    showConfirmButton: true,
  });

  success(message: string) {
    return this.toast.fire({
      icon: 'success',
      title: message,
    });
  }

  error(message: string) {
    return this.toast.fire({
      icon: 'error',
      title: message,
      timer: 3000,
    });
  }

  warning(message: string) {
    return this.toast.fire({
      icon: 'warning',
      title: message,
    });
  }

  info(message: string) {
    return this.toast.fire({
      icon: 'info',
      title: message,
    });
  }

  loading(message: string = 'Please wait...') {
    return this.modal.fire({
      title: message,
      didOpen: () => {
        Swal.showLoading();
      },
      showConfirmButton: false,
    });
  }

  confirm(options: {
    title: string;
    text: string;
    confirmButtonText?: string;
    cancelButtonText?: string;
    confirmButtonClass?: string;
    cancelButtonClass?: string;
  }) {
    return this.modal.fire({
      title: options.title,
      text: options.text,
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: options.confirmButtonText || 'Yes',
      cancelButtonText: options.cancelButtonText || 'No',

      reverseButtons: true,
      customClass: {
        confirmButton:
          options.confirmButtonClass ||
          'bg-buttonBlue text-white px-6 py-2 rounded-md text-m mr-4 w-auto',
        cancelButton:
          options.cancelButtonClass ||
          'bg-white border border-gray-400 text-gray-800 px-6 py-2 rounded-md text-m w-auto',
      },
    });
  }
}
